<script lang="ts" setup>
const { createEvent } = useAnalytics()
const { t } = useI18n()

onMounted(() => {
  createEvent({ name: '[Navigation] Visit Settings API Tokens & Usage' })
})
</script>

<template>
  <UCard>
    <UDashboardSection
      :description="t('tokens.description')"
      orientation="horizontal"
      :title="t('tokens.title')"
      :ui="{ wrapper: 'lg:grid-cols-1 xl:grid-cols-2 first:*:col-span-1 last:*:col-span-1 gap-8' }"
    >
      <ApiTokensBox :has-borders="false" />
    </UDashboardSection>
  </UCard>
</template>

<i18n lang="json">
{
  "en": {
    "tokens": {
      "description": "The Companies API uses tokens to authenticate API requests. They are permanent and carry many privileges, so keep them secure!",
      "title": "Your team's API tokens"
    }
  },
  "es": {
    "tokens": {
      "description": "The Companies API uses tokens to authenticate API requests. They are permanent and carry many privileges, so keep them secure!",
      "title": "Los tokens API de tu equipo"
    }
  },
  "fr": {
    "tokens": {
      "description": "The Companies API utilise des tokens pour authentifier les requêtes API. Ils sont permanents et confèrent de nombreux privilèges, alors gardez-les en sécurité !",
      "title": "Les tokens API de votre équipe"
    }
  }
}
</i18n>
